import React from "react";

const ManagerKPI = ({ kpiData }) => {
  const getRows = () => {
    if (kpiData && Array.isArray(kpiData.tasks)) {
      return kpiData.tasks.map((t, idx) => ({
        id: t.task || String(idx),
        name: t.task,
        target: t.target !== undefined ? t.target : 0,
        achievement: t.achievement !== undefined ? t.achievement : 0,
        rate: t.rate || "0%",
        color: t.color || "red",
      }));
    }

    return [
      {
        id: "active",
        name: "ACTIVE USERS",
        target: kpiData?.active?.target || 50,
        achievement: kpiData?.active?.achievement || 0,
        rate: kpiData?.active?.rate || "0%",
        color: kpiData?.active?.color || "red",
      },
      {
        id: "trans",
        name: "TRANSACTIONS",
        target: kpiData?.trans?.target || 100,
        achievement: kpiData?.trans?.achievement || 0,
        rate: kpiData?.trans?.rate || "0%",
        color: kpiData?.trans?.color || "red",
      },
      {
        id: "apis",
        name: "APIs",
        target: kpiData?.apis?.target || 5,
        achievement: kpiData?.apis?.achievement || 0,
        rate: kpiData?.apis?.rate || "0%",
        color: kpiData?.apis?.color || "red",
      },
    ];
  };

  const rows = getRows();

  return (
    <div className="bg-white dark:bg-[#0B0F19] rounded-3xl border border-slate-200 dark:border-slate-800 p-6 md:p-8 shadow-2xl relative overflow-hidden">
      {/* Background Decor */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-sky-500/5 rounded-full blur-[80px] pointer-events-none"></div>

      <h3 className="text-xl font-black text-slate-800 dark:text-white tracking-tight mb-6 flex items-center gap-3">
        <svg className="w-6 h-6 text-sky-500 dark:text-sky-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5">
          <path strokeLinecap="round" strokeLinejoin="round" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
        </svg>
        Performance KPI
      </h3>

      <div className="overflow-x-auto w-full custom-scrollbar">
        <table className="w-full max-w-xl text-left border-collapse">
          <thead>
            <tr className="border-b-2 border-slate-200 dark:border-slate-800 text-slate-500 dark:text-slate-400 uppercase tracking-widest text-[10px] md:text-xs">
              <th className="py-4 px-4 font-black">Task</th>
              <th className="py-4 px-4 font-black text-center">Target</th>
              <th className="py-4 px-4 font-black text-center">Achievement</th>
              <th className="py-4 px-4 font-black text-right">Rate</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-200 dark:divide-slate-800/50">
            {rows.map((row) => {
              // Map the API string colors to Tailwind classes
              let colorClasses = "text-slate-500 dark:text-slate-400 bg-slate-100 dark:bg-slate-800/50 border border-slate-200 dark:border-slate-700";
              if (row.color) {
                const c = row.color.toLowerCase();
                if (c.includes("green") || c.includes("emerald") || c.includes("success")) {
                  colorClasses = "text-emerald-600 dark:text-emerald-400 bg-emerald-50 dark:bg-emerald-500/10 border border-emerald-100 dark:border-emerald-500/20";
                } else if (c.includes("yellow") || c.includes("orange") || c.includes("warning")) {
                  colorClasses = "text-yellow-600 dark:text-yellow-400 bg-yellow-50 dark:bg-yellow-500/10 border border-yellow-100 dark:border-yellow-500/20";
                } else if (c.includes("red") || c.includes("rose") || c.includes("danger")) {
                  colorClasses = "text-rose-600 dark:text-rose-400 bg-rose-50 dark:bg-rose-500/10 border border-rose-100 dark:border-rose-500/20";
                }
              }

              return (
                <tr key={row.id} className="hover:bg-slate-50 dark:hover:bg-slate-800/30 transition-all duration-200 group">
                  <td className="py-4 px-4 font-bold text-slate-800 dark:text-slate-200 text-sm md:text-base whitespace-nowrap">
                    {row.name}
                  </td>
                  <td className="py-4 px-4 font-bold text-slate-600 dark:text-slate-300 text-center font-mono">
                    {row.target.toLocaleString()}
                  </td>
                  <td className="py-4 px-4 font-bold text-slate-600 dark:text-slate-300 text-center font-mono">
                    {row.achievement.toLocaleString()}
                  </td>
                  <td className="py-4 px-4 text-right">
                    <span className={`inline-flex items-center justify-center min-w-[3.5rem] px-3 py-1.5 rounded-lg text-xs font-black tracking-widest ${colorClasses} shadow-sm transition-all duration-300`}>
                      {row.rate}
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ManagerKPI;
